import { createAction } from '@reduxjs/toolkit';

const ACTION_BASE_TYPE = 'FEEDBACK';

export const setFeedback = createAction<string>(
  `${ACTION_BASE_TYPE}/SET_RETURN_ITEMS`
);
